import React, { useState, useEffect } from "react";
import images from "../../../constant/images";
import { Nav } from "../../../layouts/navbar/nav";
import play from "../../../assets/images/play.png";
import apple from "../../../assets/images/apple.png";
import { useSelector, useDispatch } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import { storeToken, storeUser, storeLanguage, storeCount } from "../../../formSlice";
import { useTranslation } from "react-i18next";

export default function LoginPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const lang = useSelector((state) => state.gtm.form.lang); // Get the language from Redux state
  const user = localStorage.getItem("user");
; // adjust according to your state
  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const language = localStorage.getItem("i18nextLng");

  const baseUrl = useSelector((state) => state.gtm.baseUrl);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailValidated, setEmailValidated] = useState(false);
  const [passwordValidated, setPasswordValidated] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [hidePass, setHidePass] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const locale = navigator.language.split("-")[0];

  // Change language and update Redux state


  // Sync i18n language with Redux state on component mount

  // Validate email on change
  const handleEmailChange = (text) => {
    const domainPattern = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const domain = text.split("@")[1];

    switch (true) {
      case text.length === 0:
        setMessage("Email is required.");
        setEmailValidated(false);
        break;
      case !text.includes("@"):
        setMessage('Email must contain "@" symbol.');
        setEmailValidated(false);
        break;
      case text.startsWith("@") || text.endsWith("@"):
        setMessage('Email cannot start or end with "@".');
        setEmailValidated(false);
        break;
      case text.split("@").length > 2:
        setMessage('Email can only contain one "@" symbol.');
        setEmailValidated(false);
        break;
      case !domain:
        setMessage("Email domain is missing.");
        setEmailValidated(false);
        break;
      case !domainPattern.test(domain):
        setMessage("Email domain is invalid.");
        setEmailValidated(false);
        break;
      default:
        setMessage("");
        setEmailValidated(true);
    }
    setEmail(text);
  };

  // Validate password on change
  const handlePasswordChange = (text) => {
    if (text.length < 8) {
      setMessage("Password should contain at least 8 characters !");
      setPasswordValidated(false);
    } else {
      setMessage("");
      setPasswordValidated(true);
    }
    setPassword(text);
  };

  const getCount = async (id) => {
    try {
      const response = await axios.get(`${baseUrl}/count` , {params : {id: id}});
      dispatch(storeCount(response.data.count));
    } catch (error) {

    } 
  };

  // Login handler
  const login = async () => {
    try {
      setIsLoading(true);
      const response = await axios.post(
        `${baseUrl}/login`,
        {
          email,
          password,
          lang: locale,
        },
        {
          withCredentials: true,
          withXSRFToken: true,
          credentials: "include",
        }
      );

      if (response.data.status.trim() === "success") {
        dispatch(storeToken(response.data.token));
        localStorage.setItem("userToken", response.data.token);
        dispatch(storeUser(response.data.user));
        getCount(response.data.user.id);
        const membership = response.data.user.membership;
        if (response.status === 200) {
          if (membership?.status === "valid") {
            navigate("/membership/welcome");
          } else if (response.data.user.free_pack == 1) {
            navigate("/membership/welcome");
          } else {
            navigate("/");
          }
        }
      }
    } catch (err) {
      console.error(err.response?.data);
      setError(err.response?.data.message || "Login failed");
    } finally {
      setIsLoading(false);
    }
  };


  

  

  return (
    <div
      className="flex flex-col gap-12 min-h-screen"
      style={{
        backgroundImage: `url(${images.golf_field})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: "relative",
      }}
    >
      <div>
        <Nav />
      </div>

      {/* Login Container */}
      <div className="flex items-center justify-center w-full mb-32">
        <div className="shadow-custom bg-white p-4 md:p-12 rounded-xl w-full max-w-[80%] sm:max-w-[620px] text-center mt-0 md:mt-2.5">
          {/* Title */}
          <h3 className="text-2xl sm:text-3xl mb-6 sm:mb-8 text-center font-semibold text-black mx-auto">
            {t("login.login")}
          </h3>

          {/* Login Form */}
          <form className="space-y-4">
            {/* Input Fields */}
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="bg-[#F4F5F9] border-none rounded-xl py-3 px-5 mb-3.5 w-full max-w-full sm:max-w-[500px] mx-auto block placeholder-[#A4A4A4]"
              placeholder={t("login.email")}
              required
            />
            <input
              type="password"
              name="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="bg-[#F4F5F9] border-none rounded-xl py-3 px-5 mb-3.5 w-full max-w-full sm:max-w-[500px] mx-auto block placeholder-[#A4A4A4]"
              placeholder={t("login.password")}
              required
            />

            {/* Display error */}
            {error && <p className="text-red-500">{error}</p>}
            <div className="flex justify-end items-center mb-4">
              <NavLink
                to="/request_change_password"
                className=" text-[#0D70A1] hover:underline"
              >
                {t("login.forget_password")}
              </NavLink>
            </div>

            {/* reCAPTCHA - Adjust scaling for mobile */}
            <div className="flex justify-center mb-5">
              <div
                className="g-recaptcha scale-75 md:scale-[0.85] origin-left-top"
                data-sitekey="your-site-key"
              ></div>
            </div>

            {/* Buttons */}
            <div className="space-y-4">
              <button
                type="submit"
                disabled={isLoading}
                onClick={login}
                className="w-full sm:max-w-[350px] py-3 text-base rounded-[33px] bg-black font-semibold border-none cursor-pointer mx-auto block hover:bg-[#333] text-white"
              >
                {isLoading
                  ? `${t("twichiyat.loading")}`
                  : `${t("login.login")}`}
              </button>

              <div className="flex flex-col items-center gap-2 mt-[40px]">
                <p className="font-bold text-sm sm:text-base">
                  {t("login.not_a_member")}
                </p>
                <NavLink
                  to="/register"
                  className="w-full sm:max-w-[350px] py-3 text-base rounded-[33px] bg-[#00573f] font-semibold border-none cursor-pointer mx-auto block hover:opacity-80 text-white"
                >
                  {t("login.join")}
                </NavLink>
              </div>
            </div>

            {/* Download Links */}
            <div className="flex flex-col items-center justify-center gap-1">
              <h6 className="mt-6 mb-4 text-center text-sm sm:text-base ">
                {t("login.download_app")} <br /> {t("login.p2")}
              </h6>
              <div className="flex justify-center gap-4">
                <NavLink
                  to="https://apps.apple.com/ma/app/golf-trips-morocco/id6743395137"
                  target="_blank"
                >
                  <img
                    src={apple}
                    alt="App Store"
                    className="max-h-[40px] sm:max-h-[50px]"
                  />
                </NavLink>
                <NavLink
                  to="https://play.google.com/store/apps/details?id=com.golftripsmorocco.gtm"
                  target="_blank"
                >
                  <img
                    src={play}
                    alt="Google Play"
                    className="max-h-[40px] sm:max-h-[50px]"
                  />
                </NavLink>
              </div>
            </div>

            {/* Footer Text */}
            <div className="text-[7px] xs:text-xs sm:text-[12px] text-center text-[#666] pt-[40px]">
              {t("login.help_message")} <br className="hidden xs:block" />
              {language === "fr" ? "Voir les" : "See the"}{" "}
              <NavLink
                to="/termes-et-conditions"
                className="text-blue-500 no-underline hover:underline"
              >
                {language === "fr"
                  ? "Conditions d'utilisation"
                  : "Terms of Use"}
              </NavLink>
              ,{" "}
              <NavLink
                to="/conditions-de-notification"
                className="text-blue-500 no-underline hover:underline"
              >
                {language === "fr"
                  ? "Conditions de notification"
                  : "Notification conditions"}
              </NavLink>
              ,{" "}
              <NavLink
                to="/conditions-de-paiement"
                className="text-blue-500 no-underline hover:underline"
              >
                {language === "fr"
                  ? "Conditions de paiement"
                  : "Payment conditions"}
              </NavLink>
              {language === "fr" ? ", et la" : ", and"}{" "}
              <NavLink
                to="/politique-de-confidentialite"
                className="text-blue-500 no-underline hover:underline"
              >
                {language === "fr"
                  ? "politique de confidentialité"
                  : "Privacy Policy"}
              </NavLink>
              .
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
